export default __webpack_public_path__ + "fa074a9ae8c63ee6e3c2dde1fdc97ec8.svg";